import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { logAndThrowError } from '../utils/errors';
const ApiContext = createContext(undefined);
export function ApiProvider({ children, client }) {
    return _jsx(ApiContext.Provider, { value: client, children: children });
}
export function useApi() {
    const context = useContext(ApiContext);
    if (!context) {
        logAndThrowError('useApi must be used within an ApiProvider');
    }
    return context;
}
